import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

//constants

//validators
import { dropDownValidator, emailValidator } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';
import * as util from '../../util/index'

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { YesNoDropdownComponent } from '../DomainData/YesNoDropdown.component';
import { SalesOfficeDropdownComponent } from '../DomainData/SalesOfficeDropdown.component';

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';

@Component({
    selector: 'my-support-required-details',
    templateUrl: './SupportRequiredDetails.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => SupportRequiredDetailsComponent) }]
})
export class SupportRequiredDetailsComponent extends BaseControlGroupComponent {

    public form: FormGroup;
    supportRequiredInfo: ent.SupportRequiredInfo = new ent.SupportRequiredInfo();
    requiredAttachments: ent.AttachmentType[] = [];
    billingDiscrepancyRequestTypeID: number;

    @ViewChild('requestedRefundInvoicePaid') public requestedRefundInvoicePaidDropdownComponent: YesNoDropdownComponent;
    @ViewChild('canCreditOffsetBalance') public canCreditOffsetBalanceDropdownComponent: YesNoDropdownComponent;
    @ViewChild('refundSentToAddressOnFile') public refundSentToAddressOnFileDropdownComponent: YesNoDropdownComponent;
    @ViewChild(SalesOfficeDropdownComponent) public salesOfficeDropdownComponent: SalesOfficeDropdownComponent;

    @Input() public showProjectStartDate: boolean;
    @Input() public showProjectEndDate: boolean;
    @Input() public showPPG: boolean;
    @Input() public showMaterial: boolean;
    @Input() public showCorrectAmountToBeCharged: boolean;
    @Input() public showTradeLetterPAW: boolean;
    @Input() public showInvoiceDate: boolean;
    @Input() public showPostingDate: boolean;
    @Input() public showReferenceNumber: boolean;
    @Input() public showAmountToBeReinstated: boolean;
    @Input() public showGLAccountNumber: boolean;
    @Input() public showProfitCenterCostCenter: boolean;
    @Input() public showAdditionalText: boolean;
    @Input() public showInvoiceNumber: boolean;
    @Input() public showRequestedRefundInvoicePaid: boolean;
    //@Input() public showCanCreditOffsetBalance: boolean;
    @Input() public showCustomerPaymentType: boolean;
    @Input() public showMOVOffDayFeeChargedAmount: boolean;
    @Input() public showRefundSentToAddressOnFile: boolean;
    //@Input() public showRefundAddress: boolean;
    @Input() public showSalesOffice: boolean;


    @Input() public requireProjectStartDate: boolean;
    @Input() public requireProjectEndDate: boolean;
    @Input() public requirePPG: boolean;
    @Input() public requireMaterial: boolean;
    @Input() public requireCorrectAmountToBeCharged: boolean;
    @Input() public requireTradeLetterPAW: boolean;
    @Input() public requireInvoiceDate: boolean;
    @Input() public requirePostingDate: boolean;
    @Input() public requireReferenceNumber: boolean;
    @Input() public requireAmountToBeReinstated: boolean;
    @Input() public requireGLAccountNumber: boolean;
    @Input() public requireProfitCenterCostCenter: boolean;
    @Input() public requireAdditionalText: boolean;
    @Input() public requireInvoiceNumber: boolean;
    @Input() public requireRequestedRefundInvoicePaid: boolean;
    //@Input() public requireCanCreditOffsetBalance: boolean;
    @Input() public requireCustomerPaymentType: boolean;
    @Input() public requireMOVOffDayFeeChargedAmount: boolean;
    @Input() public requireRefundSentToAddressOnFile: boolean;
    //@Input() public requireRefundAddress: boolean;
    @Input() public requireSalesOffice: boolean;

    setDates() {
        this.supportRequiredInfo.ProjectStartDate = util.DateUtil.ConvertDateToJS(this.supportRequiredInfo.ProjectStartDate);
        this.supportRequiredInfo.ProjectEndDate = util.DateUtil.ConvertDateToJS(this.supportRequiredInfo.ProjectEndDate);
        this.supportRequiredInfo.InvoiceDate = util.DateUtil.ConvertDateToJS(this.supportRequiredInfo.InvoiceDate);
        this.supportRequiredInfo.PostingDate = util.DateUtil.ConvertDateToJS(this.supportRequiredInfo.PostingDate);
    }

    setRequestInfo(request: ent.Request) {
        this.request = request;
        this.supportRequiredInfo = request.SupportRequiredInfo;

        if (this.requestedRefundInvoicePaidDropdownComponent) {
            if (this.supportRequiredInfo.RequestedRefundInvoicePaid == null) {
                this.requestedRefundInvoicePaidDropdownComponent.value = Constants._NONE;
            } else if (this.supportRequiredInfo.RequestedRefundInvoicePaid == true) {
                this.requestedRefundInvoicePaidDropdownComponent.value = Constants._YES;
            } else {
                this.requestedRefundInvoicePaidDropdownComponent.value = Constants._NO;
            }
        }
        if (this.canCreditOffsetBalanceDropdownComponent) {
            if (this.supportRequiredInfo.CanCreditOffsetBalance == null) {
                this.canCreditOffsetBalanceDropdownComponent.value = Constants._NONE;
            } else if (this.supportRequiredInfo.CanCreditOffsetBalance == true) {
                this.canCreditOffsetBalanceDropdownComponent.value = Constants._YES;
            } else {
                this.canCreditOffsetBalanceDropdownComponent.value = Constants._NO;
            }
        }
        if (this.refundSentToAddressOnFileDropdownComponent) {
            if (this.supportRequiredInfo.RefundSentToAddressOnFile == null) {
                this.refundSentToAddressOnFileDropdownComponent.value = Constants._NONE;
            } else if (this.supportRequiredInfo.RefundSentToAddressOnFile == true) {
                this.refundSentToAddressOnFileDropdownComponent.value = Constants._YES;
            } else {
                this.refundSentToAddressOnFileDropdownComponent.value = Constants._NO;
            }
        }
        this.salesOfficeDropdownComponent.selectedID = this.supportRequiredInfo.SalesOfficeID;


    }

    constructor(fb: FormBuilder) {
        super();
        let group = {
            'projectStartDate': '',
            'projectEndDate': '',
            'ppg': '',
            'material': '',
            'correctAmountToBeCharged': '',
            'tradeLetterPAW': '',
            'invoiceDate': '',
            'postingDate': '',
            'referenceNumber': '',
            'amountToBeReinstated': '',
            'glAccountNumber': '',
            'profitCenterCostCenter': '',
            'additionalText': '',
            'invoiceNumber': '',
            'requestedRefundInvoicePaid': '',
            'canCreditOffsetBalance': '',
            'customerPaymentType': '',
            'movOffDayFeeChargedAmount': '',
            'refundSentToAddressOnFile': '',
            'refundAddressReadonly': '',
            'refundAddress': '',
            'salesOffice': '',
        };

        this.form = fb.group(group);

    }


    ngOnInit(): void {
    }

    // ngAfterViewInit() {
    //     this.requestedRefundInvoicePaidDropdownComponent.load();
    //     this.canCreditOffsetBalanceDropdownComponent.load();
    // }

    handleRequestType(requestTypeID: number) {
        this.showProjectStartDate = false;
        this.showProjectEndDate = false;
        this.showPPG = false;
        this.showMaterial = false;
        this.showCorrectAmountToBeCharged = false;
        this.showTradeLetterPAW = false;
        this.showInvoiceDate = false;
        this.showPostingDate = false;
        this.showReferenceNumber = false;
        this.showAmountToBeReinstated = false;
        this.showGLAccountNumber = false;
        this.showProfitCenterCostCenter = false;
        this.showAdditionalText = false;
        this.showInvoiceNumber = false;
        this.showRequestedRefundInvoicePaid = false;
        //this.showCanCreditOffsetBalance = false;
        this.showCustomerPaymentType = false;
        this.showMOVOffDayFeeChargedAmount = false;
        this.showRefundSentToAddressOnFile = false;
        //this.showRefundAddress = false;
        this.showSalesOffice = false;

        this.form.controls.projectStartDate.clearValidators();
        this.form.controls.projectEndDate.clearValidators();
        this.form.controls.ppg.clearValidators();
        this.form.controls.material.clearValidators();
        this.form.controls.correctAmountToBeCharged.clearValidators();
        this.form.controls.tradeLetterPAW.clearValidators();
        this.form.controls.invoiceDate.clearValidators();
        this.form.controls.postingDate.clearValidators();
        this.form.controls.referenceNumber.clearValidators();
        this.form.controls.amountToBeReinstated.clearValidators();
        this.form.controls.glAccountNumber.clearValidators();
        this.form.controls.profitCenterCostCenter.clearValidators();
        this.form.controls.additionalText.clearValidators();
        this.form.controls.invoiceNumber.clearValidators();
        this.form.controls.requestedRefundInvoicePaid.clearValidators();
        this.form.controls.canCreditOffsetBalance.clearValidators();
        this.form.controls.customerPaymentType.clearValidators();
        this.form.controls.movOffDayFeeChargedAmount.clearValidators();
        this.form.controls.refundSentToAddressOnFile.clearValidators();
        this.form.controls.refundAddress.clearValidators();
        this.form.controls.refundAddressReadonly.clearValidators();
        this.form.controls.salesOffice.clearValidators();

        this.form.controls.projectStartDate.updateValueAndValidity();
        this.form.controls.projectEndDate.updateValueAndValidity();
        this.form.controls.ppg.updateValueAndValidity();
        this.form.controls.material.updateValueAndValidity();
        this.form.controls.correctAmountToBeCharged.updateValueAndValidity();
        this.form.controls.tradeLetterPAW.updateValueAndValidity();
        this.form.controls.invoiceDate.updateValueAndValidity();
        this.form.controls.postingDate.updateValueAndValidity();
        this.form.controls.referenceNumber.updateValueAndValidity();
        this.form.controls.amountToBeReinstated.updateValueAndValidity();
        this.form.controls.glAccountNumber.updateValueAndValidity();
        this.form.controls.profitCenterCostCenter.updateValueAndValidity();
        this.form.controls.additionalText.updateValueAndValidity();
        this.form.controls.invoiceNumber.updateValueAndValidity();
        this.form.controls.requestedRefundInvoicePaid.updateValueAndValidity();
        this.form.controls.canCreditOffsetBalance.updateValueAndValidity();
        this.form.controls.customerPaymentType.updateValueAndValidity();
        this.form.controls.movOffDayFeeChargedAmount.updateValueAndValidity();
        this.form.controls.refundSentToAddressOnFile.updateValueAndValidity();
        this.form.controls.refundAddress.updateValueAndValidity();
        this.form.controls.refundAddressReadonly.updateValueAndValidity();
        this.form.controls.salesOffice.updateValueAndValidity();



        var filter: filters.AttachmentTypeFilter = { BillingDiscrepancyRequestTypeID: requestTypeID }
        this.domainDataService.getAttachmentTypes(filter).subscribe(x => {
            this.requiredAttachments = x;
        });

        this.billingDiscrepancyRequestTypeID = requestTypeID;
        switch (requestTypeID) {
            case enums.BillingDiscrepancyRequestTypeEnum.PricingDiscrepancyCorrection:
                this.showProjectStartDate = true;
                this.showProjectEndDate = true;
                this.showPPG = true;
                this.showMaterial = true;
                this.showCorrectAmountToBeCharged = true;
                this.showTradeLetterPAW = true;
                this.showInvoiceNumber = true;

                this.form.controls.projectStartDate.setValidators(Validators.required);
                this.form.controls.projectEndDate.setValidators(Validators.required);
                this.form.controls.ppg.setValidators(Validators.required);
                this.form.controls.material.setValidators(Validators.required);
                this.form.controls.correctAmountToBeCharged.setValidators(Validators.required);
                this.form.controls.tradeLetterPAW.setValidators(Validators.required);
                this.form.controls.invoiceNumber.setValidators(Validators.required);

                break;
            case enums.BillingDiscrepancyRequestTypeEnum.SalesTaxCorrection:

                break;
            case enums.BillingDiscrepancyRequestTypeEnum.CreditMemoReinstate:
                this.showInvoiceDate = true;
                this.showPostingDate = true;
                this.showReferenceNumber = true;
                this.showAmountToBeReinstated = true;
                this.showProfitCenterCostCenter = true;
                this.showAdditionalText = true;

                this.form.controls.invoiceDate.setValidators(Validators.required);
                this.form.controls.postingDate.setValidators(Validators.required);
                this.form.controls.referenceNumber.setValidators(Validators.required);
                this.form.controls.amountToBeReinstated.setValidators(Validators.required);
                this.form.controls.profitCenterCostCenter.setValidators(Validators.required);
                this.form.controls.additionalText.setValidators(Validators.required);
                break;
            case enums.BillingDiscrepancyRequestTypeEnum.CRVCorrection:

                break;
            case enums.BillingDiscrepancyRequestTypeEnum.MOV_MOQOffDayCorrection:
                this.showRequestedRefundInvoicePaid = true;
                //this.showCanCreditOffsetBalance = true;
                this.showCustomerPaymentType = true;
                this.showMOVOffDayFeeChargedAmount = true;
                this.showRefundSentToAddressOnFile = true;
                //this.showRefundAddress = true;
                this.showSalesOffice = true;

                //this.form.controls.requestedRefundInvoicePaid.setValidators([dropDownValidator, Validators.required]);
                //this.form.controls.movOffDayFeeChargedAmount.setValidators([dropDownValidator, Validators.required]);
                this.form.controls.customerPaymentType.setValidators([dropDownValidator, Validators.required]);
                this.form.controls.salesOffice.setValidators([dropDownValidator, Validators.required]);
                //this.form.controls.refundSentToAddressOnFileChange.setValidators([dropDownValidator, Validators.required]);
                this.form.controls.salesOffice.setValidators(Validators.required);
                this.form.controls.refundAddressReadonly.setValidators(Validators.required);
                break;
            default:
                break;
        }
    }

    requestedRefundInvoicePaidChange(event: any) {
        if (event == Constants._NONE) {
            this.supportRequiredInfo.RequestedRefundInvoicePaid = null;
        }
        else if (event == Constants._YES) {
            this.supportRequiredInfo.RequestedRefundInvoicePaid = true;
        } else {
            this.supportRequiredInfo.RequestedRefundInvoicePaid = false;
        }
    }

    canCreditOffsetBalanceChange(event: any) {
        if (event == Constants._NONE) {
            this.supportRequiredInfo.CanCreditOffsetBalance = null;
        }
        else if (event == Constants._YES) {
            this.supportRequiredInfo.CanCreditOffsetBalance = true;
        } else {
            this.supportRequiredInfo.CanCreditOffsetBalance = false;
        }
    }

    refundSentToAddressOnFileChange(event: any) {
        if (event == Constants._NONE) {
            this.supportRequiredInfo.RefundSentToAddressOnFile = null;
        }
        else if (event == Constants._YES) {
            this.supportRequiredInfo.RefundSentToAddressOnFile = true;
        } else {
            this.supportRequiredInfo.RefundSentToAddressOnFile = false;
        }
    }

    customerPaymentTypeChange(event: any) {
        this.supportRequiredInfo.CustomerPaymentTypeID = event;
    }

    salesOfficeChange(event: any) {
        this.supportRequiredInfo.SalesOfficeID = event;
    }

    refundAddressChanged(address: ent.MyAddress) {
        this.supportRequiredInfo.RefundAddress = address.FormattedAddress;
    }

    showRequestedRefundInvoicePaidRequiredValidator(): boolean {
        return this.supportRequiredInfo.RequestedRefundInvoicePaid === null;
    }

    showRefundSentToAddressOnFileRequiredValidator(): boolean {
        return this.supportRequiredInfo.RefundSentToAddressOnFile === null;
    }

    showCanCreditOffsetBalanceRequiredValidator(): boolean {
        return this.supportRequiredInfo.CanCreditOffsetBalance === null;
    }

    showCanCreditOffsetBalance(): boolean {
        return this.billingDiscrepancyRequestTypeID == enums.BillingDiscrepancyRequestTypeEnum.MOV_MOQOffDayCorrection &&
            this.supportRequiredInfo.RequestedRefundInvoicePaid != null && this.supportRequiredInfo.RequestedRefundInvoicePaid === false;
    }

    showRefundAddress(): boolean {
        return this.billingDiscrepancyRequestTypeID == enums.BillingDiscrepancyRequestTypeEnum.MOV_MOQOffDayCorrection &&
            this.supportRequiredInfo.RefundSentToAddressOnFile != null && this.supportRequiredInfo.RefundSentToAddressOnFile === false;
    }



}